const COMMENTABLE_MODEL = {
  event: 'event',
  post: 'post',
};

export default COMMENTABLE_MODEL;
